import { SwipeableDrawer } from "@mui/material";
import React, { useContext, useState } from "react";
import "../../CSS/Drawer.css";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { cashierLang } from "../language/pages/cashierPageLang";
import useLanguage from "../language/useLanguage";
import { appContext } from "../../navbar/auth";
import moment from "moment";

const Drawer = ({ allInvoices, paidInvoices, unPaidInvoices }) => {
  const lan = useLanguage(cashierLang);
  //drawer
  const [state, setState] = React.useState(false);
  const {
    setInvoiceId,
    invoiceType,
    setinvoiceType,
    invoicePaidUnpaid,
    setInvoicePaidUnpaid,
  } = useContext(appContext);

  const handleIVInput = (e) => {
    setInvoiceId(e.id);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  // const [invoiceType, setinvoiceType] = useState('All');

  const handleChange = (e) => {
    setinvoiceType(e.target.value);

    e.target.value === "All" && setInvoicePaidUnpaid(allInvoices);

    e.target.value === "Paid" && setInvoicePaidUnpaid(paidInvoices);

    e.target.value === "Unpaid" && setInvoicePaidUnpaid(unPaidInvoices);
  };
  console.log(invoiceType);
  const formatResult = (item) => {
    return (
      <>
        <div
          className={`row d-flex align-items-center search-format ${
            item.stock < 1 ? "bg-red text-white" : ""
          } `}
        >
          <div className="col-12">
            <p>{item?.invoice_no}</p>
          </div>
          {/* <div className='col-3'>
                        <p>{item?.drug?.manufacturer}</p>
                    </div> */}
        </div>
      </>
    );
  };
  const [searchInvoice, setSearchInvoice] = useState("");
  const medicineSelect = (item) => {
    setInvoiceId(item.id);
    setSearchInvoice("");
  };
  console.log(invoicePaidUnpaid, "ddf");
  return (
    <div>
      <button
        className="btn btn-primary btn-sm rounded px-2 mt-1 ms-4"
        onClick={toggleDrawer(true)}
      >
        {lan?.allInvoice}
      </button>
      <SwipeableDrawer
        anchor={"right"}
        open={state}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <div style={{ width: "600px" }} className="overflow-hidden">
          <div>
            <i
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={toggleDrawer(false)}
              className="float-right fa fa-times m-2"
            ></i>
          </div>

          <div className="d-flex justify-content-center custom_button">
            <div
              className="btn-group btn-group-sm"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              <input
                value="All"
                checked={invoiceType === "All"}
                onChange={handleChange}
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio1"
                autoComplete="off"
              />
              <label className="btn btn-outline-success" htmlFor="btnradio1">
                {lan?.all}
              </label>

              <input
                value="Paid"
                checked={invoiceType === "Paid"}
                onChange={handleChange}
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio2"
                autoComplete="off"
              />
              <label className="btn btn-outline-success" htmlFor="btnradio2">
                {lan?.paid}
              </label>

              <input
                value="Unpaid"
                checked={invoiceType === "Unpaid"}
                onChange={handleChange}
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio3"
                autoComplete="off"
              />
              <label className="btn btn-outline-success" htmlFor="btnradio3">
                {lan?.unpaid}
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-1">
            <div style={{ margin: "0 50px" }} className="w-100">
              <ReactSearchAutocomplete
                showIcon={false}
                placeholder={lan?.searchInvoice}
                inputSearchString={searchInvoice || ""}
                onSearch={(value) => setSearchInvoice(value)}
                items={invoicePaidUnpaid}
                resultStringKeyName="invoice_no"
                maxResults={3}
                onSelect={(item) => medicineSelect(item)}
                autoFocus
                fuseOptions={{ keys: ["invoice_no", "member_phone"] }} // Search in the description text as well
                styling={{
                  borderRadius: "5px !important",
                  zIndex: 0,
                  minHeight: "36px",
                  position: "static",
                  height: "36px",
                  fontSize: "13px",
                }}
                formatResult={formatResult}
              />
            </div>
          </div>

          <div className="all-invoice-container p-2 h-75 overflow-auto">
            <table className="">
              <thead>
                <tr className="all-invoice-thead  py-2">
                  <th>{lan?.invoiceNo}</th>
                  <th>Date</th>
                  <th>{lan?.status}</th>
                  <th>Customer</th>
                  <th>Mobile</th>
                </tr>
              </thead>
              <tbody>
              {invoiceType === "All" &&
                allInvoices.map((inv) => (
                  <tr
                    key={inv.id}
                    onClick={() => {
                      setInvoiceId(inv.id);
                    }}
                    className="border-bottom drawer_style"
                  >
                    <td className="drawer_style">{inv.invoice_no}</td>
                    <td>{moment(inv?.date).format("DD-MM-YYYY")}</td>
                    <td>
                      {inv?.payment_status === "Paid"
                        ? lan?.paid
                        : inv?.payment_status === "Unpaid"
                        ? lan?.unpaid
                        : inv?.payment_status === "Partially Paid"
                        ? lan?.partiallyPaid
                        : ""}
                    </td>
                    <td>{inv?.member_name}</td>
                    <td>{inv?.mobile}</td>
                  </tr>
                ))}

              {invoiceType === "Paid" &&
                paidInvoices.map((inv) => (
                  <tr key={inv.id} className="border-bottom">
                    <td
                      className="drawer_style"
                      onClick={() => {
                        setInvoiceId(inv.id);
                      }}
                    >
                      {inv.invoice_no}
                    </td>
                    {/* <td>{inv.time}</td> */}
                    <td>
                      {inv.payment_status === "Paid"
                        ? lan?.paid
                        : inv.payment_status}
                    </td>
                  </tr>
                ))}

              {invoiceType === "Unpaid" &&
                unPaidInvoices.map((inv) => (
                  <tr key={inv.id} className="border-bottom">
                    <td
                      className="drawer_style"
                      onClick={() => {
                        setInvoiceId(inv.id);
                      }}
                    >
                      {inv.invoice_no}
                    </td>
                    {/* <td>{inv.time}</td> */}
                    <td>
                      {inv?.payment_status === "Unpaid"
                        ? lan?.unpaid
                        : inv?.payment_status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
};

export default Drawer;
